module.exports = __webpack_public_path__ + "img/cover6.2ed3501c.png";